import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { BLACK, LIGHT_BLACK, LIGHT_GREY } from "../../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: "564px",
    padding: "0 16px",
  },
  titleBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    fontSize: "24px",

    marginBottom: "32px",
  },
  storeTitle: {
    fontWeight: "600 !important",
    fontSize: "16px",
    margin: "8px 0 !important",
    color: BLACK,
  },
  storeDescription: {
    fontWeight: "400 !important",
    fontSize: "14px !important",
    color: "#616161",
  },
  imageContainer: {
    width: "140px",
    height: "140px",
    margin: "24px 0 24px 0",

    borderRadius: "4px",
    background: LIGHT_GREY,

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",

    padding: "24px",

    cursor: "pointer",

    transition: "filter 0.2s",

    "&:hover": {
      filter: "brightness(98%)",
    },
  },
  inputLogo: {
    marginBottom: "8px",
  },
  imageDescription: {
    fontWeight: "500 !important",
    fontSize: "12px !important",
    color: LIGHT_BLACK,
  },
  containerImageOptions: {
    display: "flex",
    flexDirection: "column",
    // alignItems: 'space-betwee',
    justifyContent: "space-between",

    margin: "24px 0 16px 16px",
  },
  deleteContainer: {
    width: "30px",
    height: "30px",
    borderRadius: "8px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    // margin: "24px 0 0 16px",

    transition: "background 0.2s",
    cursor: "pointer",

    "&:hover": {
      background: "#D54D4D2D",
    },
  },
  removeBackgroundOption: {
    display: "flex",
    alignItems: "center",

    cursor: "pointer",
  },
  alertRemoveBackground: {
    padding: "4px 8px 4px 4px !important",
    fontSize: "12px !important",
    fontWeight: "bold !important",
  },
  storeInformations: {
    marginBottom: "24px !important",
  },
  inputSameLine: {
    width: "100%",
    maxWidth: "262px",
  },
  containerMessageError: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    marginBottom: "16px",

    color: "#EA5151",
  },
  boxCircular: {
    width: "100%",
    height: "20rem",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
}));
